module.exports = __webpack_public_path__ + "img/level_logo2.f801f00a.png";